module.exports = __webpack_public_path__ + "static/media/koenig-white.d2c1e333.png";